import { render, staticRenderFns } from "./HotspotWidget.vue?vue&type=template&id=2a95a830"
import script from "./HotspotWidget.vue?vue&type=script&lang=js"
export * from "./HotspotWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports